import { useMutation, useQueryClient } from '@tanstack/react-query';
import type {
  AdminSetUserPasswordInput,
  ChangePasswordInput,
  LoginInput,
} from '@/features/authentication/domain/repositories/IAuthRepository.js';
import { container } from '@/shared/di/container.js';

const AUTH_SESSION_QUERY_KEY = ['auth', 'session'];

export function useAuthActions() {
  const queryClient = useQueryClient();

  const loginMutation = useMutation({
    mutationFn: (input: LoginInput) => container.auth.loginUseCase(input),
    onSuccess: (session) => {
      queryClient.setQueryData(AUTH_SESSION_QUERY_KEY, session);
    },
  });

  const changePasswordMutation = useMutation({
    mutationFn: (input: ChangePasswordInput) => container.auth.changePasswordUseCase(input),
  });

  const adminSetUserPasswordMutation = useMutation({
    mutationFn: (input: AdminSetUserPasswordInput) => container.auth.adminSetUserPasswordUseCase(input),
  });

  const logoutMutation = useMutation({
    mutationFn: () => container.auth.logoutUseCase(),
    onSuccess: () => {
      queryClient.clear();
      queryClient.setQueryData(AUTH_SESSION_QUERY_KEY, null);
    },
  });

  return {
    loginMutation,
    changePasswordMutation,
    adminSetUserPasswordMutation,
    logoutMutation,
  };
}
